import { getIndustryById } from "@/api/industries";
import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { LinkedSkillSection } from "@/components/admin/LinkedSkillSection";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { Stack } from "@mui/material";
import { useMountEffect } from "@react-hookz/web";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { IndustryInfoSection } from "./components/industry-details/IndustryInfoSection";
import { IndustryPolicyTypes } from "./components/industry-details/IndustryPolicyTypes";
import { IndustryRisksEditor } from "./components/industry-details/IndustryRisksEditor";

const AdminIndustryDetails = () => {
    const { industryId } = useParams();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Industry");

    const { data: industry } = useSuspenseQuery({
        queryKey: ["admin-industry", industryId],
        queryFn: () => getIndustryById(Number(industryId)),
    });

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Industries", path: "industries" },
            { label: industry.name },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title={industry.name}
                subtitle="Industry configuration, risks, and policy types"
            />

            <Stack spacing={3} pb={2} className="mt-6">
                <IndustryInfoSection industry={industry} />
                <LinkedSkillSection
                    entityId={industry.id}
                    entityType="industry"
                    entityName={industry.name}
                    skill={industry.skill}
                    invalidateKeys={[
                        ["admin-industry", String(industry.id)],
                        ["admin-industries"],
                    ]}
                />
                <IndustryRisksEditor industry={industry} />
                <IndustryPolicyTypes industry={industry} />
            </Stack>
        </AdminPageContent>
    );
};

export default AdminIndustryDetails;
